import { useState } from "react";
import {
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
    Button,
} from "@material-tailwind/react";

export default function InfoDialog({ title, children, onOpenChange }) {
    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen((open) => !open);
    };

    return (
        <>
            <Button
                className="btn-icon--secondary !bg-info !text-white hover:!bg-platinum hover:!text-black"
                onClick={() => setOpen(true)}
            >
                Info
            </Button>
            <Dialog
                open={open}
                handler={handleClose}
                className="dialog"
                size="lg"
            >
                <DialogHeader className="dialog__header">
                    {title || "How to on Survey"}
                </DialogHeader>
                <DialogBody className="dialog__body pt-2">
                    {children}
                </DialogBody>
                <DialogFooter className="dialog__footer">
                    <Button
                        className="btn btn--primary"
                        onClick={handleClose}
                    >
                        Close
                    </Button>
                </DialogFooter>
            </Dialog>
        </>
    );
}
